import { useContext } from 'react'
import { ProvincesContext } from '../context'

export const useGetProvinces = () => useContext(ProvincesContext)
